import moment from 'moment';
import angular from 'angular';

import BlndTable from 'app/common/table';
import editModalTpl from './templates/edit.modal.html';
import addTransTpl from './templates/add.trans.modal.html';


export class ProductsCtrl {
    constructor (NgTableParams, $rootScope, $state, $growl, Modal,
                 $company, ProductInventoryStore) {
        "ngInject";

        var self = this;
        this.Modal = Modal;
        this.company = $company;
        this.$growl = $growl;
        this.$state = $state;
        this.params = {
            page_size: 20,
            ordering: 'diff'
        };
        this.store = ProductInventoryStore;
        this.store.init();

        $rootScope.$watch('selectedObject', function (newValue) {
            self.selectedObject = newValue;
        });

        // Filter configurations by company ID;

        this.params.company = this.company.id;

        this.table = new BlndTable(NgTableParams, this.store, {defaultParams: this.params});
    }

    selectRow (objectId) {
        this.selectedObject = objectId;
        this.$state.go('r.in.top.admin.company.inventory.list.product', {objectId: objectId});
    }

    refresh () {
        return this.table.refresh(this.params);
    }
}


class EditInventoryCtrl {
    constructor (R, $uibModalInstance, $state, object) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.$state = $state;
        this.object = object;
        this.R = R;
        this.data = this.R.copy(this.object);
        this.errors = {};
    }

    get title () {
        return `Edit ${this.object.product.description}`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;

        self.loading = true;
        self.data.put().then(
            (response) => {
                angular.extend(self.object, response);
                self.$modal.close();
            },
            (response) => {
                self.errors = response.data;
            }
        ).finally(() => self.loading = false);
    }
}

class AddTransCtrl {
    constructor (R, $uibModalInstance, productInventory, InventoryTransactionStore) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.store = InventoryTransactionStore;
        this.object = productInventory;
        this.R = R;
        this.data = {
            amount: 0,
            product: productInventory.product.id,
            company: productInventory.company.id,
        };
        this.errors = {};
    }

    get title () {
        return `Add ${this.object.product.title} transaction`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        self.store.create(self.data).then(
            (response) => {
                self.$modal.close();
            },
            (response) => {
                self.errors = response.data;
            }
        ).finally(() => self.loading = false);
    }

}

export class ProductCtrl {
    constructor ($rootScope, $state, Modal, $growl, $object, $company) {
        "ngInject";
        this.object = $object;
        this.company = $company;
        this.$growl = $growl;
        this.$state = $state;
        this.Modal = Modal;

        $rootScope.object = this.object;
    }

    editModal () {
        let self = this;
        let $modal = this.Modal.open({
            template: editModalTpl,
            controller: EditInventoryCtrl,
            resolve: {
                object: () => this.object,
            },
        });

        $modal.result.then(function(){
            self.$growl.updated();
        });
    }
}

export class TransactionsCtrl {
    constructor ($rootScope, $object, $company, R, $growl, Modal, InventoryTransactionStore, NgTableParams)  {
        "ngInject";
        this.object = $object;
        this.company = $company;
        this.Modal = Modal;
        this.$growl = $growl;
        this.R = R;
        $rootScope.object = this.object;
        let start = moment().startOf('week');
        let end = moment().endOf('week');

        this.params = {
            page_size: 30,
            company: $company.id,
            product: $object.product.id,
            created_at__range: `${start.format('YYYY-MM-DD')},${end.format('YYYY-MM-DD')}`,
        };
        this.table = new BlndTable(NgTableParams, InventoryTransactionStore, {defaultParams: this.params});
        this.refreshUsage();
        this.usage = '0.0';
    }

    openAddTransaction() {
        let self = this;
        let $modal = this.Modal.open({
            template: addTransTpl,
            controller: AddTransCtrl,
            resolve: {
                productInventory: () => this.object,
            },
        });

        $modal.result.then(function(){
            self.object.get().then(obj => angular.extend(self.object, obj));
            self.table.refresh(self.params);
            self.$growl.added();
        });
    }

    refreshUsage () {
        let self = this;
        let params = {
            company: this.company.id,
            created_at__range: this.params.created_at__range
        };
        let q = this.R.one('product_inventory', this.object.id).customGET('usage', params);
        q.then(function(data){
            self.usage = data.sum;
        });
    }

   refresh () {
       this.refreshUsage();
       return this.table.refresh(this.params);
   }
}



// WEBPACK FOOTER //
// ./src/app/admin/inventory/ctrls.js